export default {
  setMenuButton (moduleVoList) {
    let buttonPermission = {}
    let menuList = []
    moduleVoList.forEach((item, i) => {
      menuList.push(item.name)
      if (item.child && item.child.length) {
        // menuList = menuList.concat(item.child.map(item => item.name))
        menuList = menuList.concat(item.child.map(item => item.name === '实名认证' ? '认证通道' : item.name))
      }
      if (item.moduleButtonVoList) {
        buttonPermission[item.name] = item.moduleButtonVoList.map(item => item.name)
      } else {
        if (item.child.length) {
          item.child.forEach((childItem, j) => {
            if (childItem.moduleButtonVoList) {
              // buttonPermission[childItem.name] = childItem.moduleButtonVoList.map(item => item.name)
              buttonPermission[childItem.name === '实名认证' ? '认证通道' : childItem.name] = childItem.moduleButtonVoList.map(item => item.name)
            }
          })
        }
      }
    })
    sessionStorage.setItem('menuList', JSON.stringify(menuList))
    sessionStorage.setItem('buttonPermission', JSON.stringify(buttonPermission))
  },
  checkMenu (menuName) {
    let menuList = JSON.parse(sessionStorage.getItem('menuList'))
    return menuList.includes(menuName)
  },
  checkButton (menuName, buttonName) {
    let buttonPermission = JSON.parse(sessionStorage.getItem('buttonPermission'))
    return buttonPermission[menuName] ? buttonPermission[menuName].includes(buttonName) : false
  }
}



// WEBPACK FOOTER //
// ./src/utils/checkPermission.js